import { getCar, getCars } from "api/cars/calls";
import { createPrimitivePaginatedHook, createPrimitiveHook } from "hooks/createPrimitiveHook";

export const useCar = createPrimitiveHook(getCar);
export const useCars = createPrimitivePaginatedHook(getCars);
